import {CopilotCodeReviewFeedback} from '@github-ui/copilot-code-review-feedback/CopilotCodeReviewFeedback'
import {useAutomatedReviewFeedback} from '../../../hooks/use-automated-review-feedback'

export interface AutomatedReviewFeedbackProps {
  automatedCommentId: string
  feedbackOptions: Array<{label: string; value: string}>
  path?: string
}

export function AutomatedReviewFeedback({automatedCommentId, feedbackOptions, path}: AutomatedReviewFeedbackProps) {
  const {feedbackPath} = useAutomatedReviewFeedback(automatedCommentId, path)

  return (
    <CopilotCodeReviewFeedback
      commentId={automatedCommentId}
      feedbackPath={feedbackPath}
      feedbackOptions={feedbackOptions}
    />
  )
}

try{ AutomatedReviewFeedback.displayName ||= 'AutomatedReviewFeedback' } catch {}